import { useIntParam } from 'hooks';
import { useState } from 'react';
import { lrwSessionStore } from 'store';

export const useLinkedSpeakingSessions = () => {
  const lrwSessionId = useIntParam('sessionId');
  const [unlinkSessionModalOpen, setUnlinkSessionModalOpen] = useState(false);
  const [unlinkingSpeakingSession, setUnlinkingSpeakingSession] = useState<number | undefined>(
    undefined
  );

  const setUnlinkingModal = (speakingSessionId: number) => {
    setUnlinkSessionModalOpen(true);
    setUnlinkingSpeakingSession(speakingSessionId);
  };

  const closeModal = () => {
    setUnlinkSessionModalOpen(false);
    setUnlinkingSpeakingSession(undefined);
  };

  const { data: linkedSpeakingSessions, isFetching: isLoadingLinkedSpeakingSessions } =
    lrwSessionStore.service.useGetLinkedSpeakingSessionsQuery({ lrwSessionId });

  return {
    lrwSessionId,
    linkedSpeakingSessions,
    isLoadingLinkedSpeakingSessions,
    unlinkSessionModalOpen,
    setUnlinkSessionModalOpen,
    unlinkingSpeakingSession,
    setUnlinkingSpeakingSession,
    setUnlinkingModal,
    closeModal,
  };
};
